import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../consts/actionTypes";
import * as API from "../api";

function* asyncGetProducts({ payload }) {
    try {
        let response = yield call(API.getProducts, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_PRODUCTS,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetProductsAdmin({ payload }) {
    try {
        let response = yield call(API.getProductsAdmin, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_PRODUCTS_ADMIN,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostProducts({ payload }) {
    try {
        let response = yield call(API.postProducts, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_PRODUCTS,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostProductsIGEN({ payload }) {
    try {
        let response = yield call(API.postProductsIGEN, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_PRODUCTS_IGEN,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPutProducts({ payload }) {
    try {
        let response = yield call(API.putProducts, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_PUT_PRODUCTS,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetProductsByCategory({ payload }) {
    try {
        let response = yield call(API.getProductsByCategory, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_PRODUCTS_BY_CATEGORY,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetProductsBySubcategory({ payload }) {
    try {
        let response = yield call(API.getProductsBySubcategory, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_PRODUCTS_BY_SUBCATEGORY,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetProductId({ payload }) {
    try {
        let response = yield call(API.getProductId, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_PRODUCT_ID,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostCreateImage({ payload }) {
    try {
        let response = yield call(API.postCreateImage, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_CREATE_IMAGE,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetSearcherProducts({ payload }) {
    try {
        let response = yield call(API.getSearcherProducts, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_SEARCHER_PRODUCTS,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPutProductChangeStatus({ payload }) {
    try {
        let response = yield call(API.putProductChangeStatus, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_PUT_PRODUCT_CHANGE_STATUS,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetSearcherProductsAdmin({ payload }) {
    try {
        let response = yield call(API.getSearcherProductsAdmin, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_SEARCHER_PRODUCTS_ADMIN,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_PRODUCT,
            response: error,
            message: error.message,
        });
    }
}

export default function* productSaga() {
    yield takeLatest(actionTypes.GET_PRODUCTS, asyncGetProducts);
    yield takeLatest(actionTypes.GET_PRODUCTS_ADMIN, asyncGetProductsAdmin);
    yield takeLatest(actionTypes.POST_PRODUCTS, asyncPostProducts);
    yield takeLatest(actionTypes.POST_PRODUCTS_IGEN, asyncPostProductsIGEN);
    yield takeLatest(actionTypes.PUT_PRODUCTS, asyncPutProducts);
    yield takeLatest(actionTypes.GET_PRODUCT_ID, asyncGetProductId);
    yield takeLatest(actionTypes.GET_PRODUCTS_BY_CATEGORY, asyncGetProductsByCategory);
    yield takeLatest(actionTypes.GET_PRODUCTS_BY_SUBCATEGORY, asyncGetProductsBySubcategory);
    yield takeLatest(actionTypes.GET_SEARCHER_PRODUCTS, asyncGetSearcherProducts);
    yield takeLatest(actionTypes.POST_CREATE_IMAGE, asyncPostCreateImage);
    yield takeLatest(actionTypes.PUT_PRODUCT_CHANGE_STATUS, asyncPutProductChangeStatus);
    yield takeLatest(actionTypes.GET_SEARCHER_PRODUCTS_ADMIN, asyncGetSearcherProductsAdmin);
}